module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMAEJYhpTMLBvnswHU5MNWMhEj06OPHtmhDLCTaqWxsxCO1AAAAnUlEQVQoz83T2Q6DIBCF4eOCuCHirm3n/R+zbUYsEG6b+F9+ISE5yeBb4gZOVORWGX65eFru4NbB0UY+W+ZjvrBGTxpnSpzJtqQUYcWDItpTTPPbqph+WmS2IsmtZiPZOsAI1tod8pUwNuQNOfG+3YVj9hmS0vCvW+zwf5VKcArQrN6Q8yFTIh0MScOKrdsA7CW5LTy6CS5AAfFreQMAFBy4R1NUJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-3.png
// module id = 4+l+
// module chunks = 1